import type { ReactNode } from "react";
import { useContext, useMemo, useState } from "react";
import { ModalContext } from "../context";

export const useHandleModalState = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [modalContent, setModalContent] = useState<ReactNode>(null);
    const [iconName, setIconName] = useState<string | undefined>(undefined);

    const openModal = () => setIsOpen(true);
    const closeModal = () => [setIsOpen(false), setIconName(undefined)];

    const value = useMemo(
        () => ({
            isOpen,
            iconName,
            modalContent,
            setModalContent,
            setIconName,
            openModal,
            closeModal,
        }),
        [isOpen, modalContent, iconName],
    );

    return value;
};

export const useModal = () => {
    const context = useContext(ModalContext);

    if (context === undefined) {
        throw new Error("useModal은 ModalProvider 안에서만 유용합니다.");
    }

    return context;
};
